import RelationshipMetadata from "../../RelationshipMetadata";

class EmployeeEmployeeAdminWorkGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EmployeeEmployeeAdminWorkGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "Employee";
        this.childEnterpriseComponent = "EmployeeAdminWorkGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default EmployeeEmployeeAdminWorkGroupRelationshipMetadata;